import { Controller } from "@hotwired/stimulus"

// Отчёт «у кого надпись не влезла». Считается на сервере по кнопке (проход по всем
// парам «слой × получатель» дёргает векторизатор), поэтому автоматически не запускаем —
// кроме случая, когда ростер только что изменили.
export default class extends Controller {
  static targets = ["body", "summary", "button"]
  static values = { url: String }

  connect() {
    // после сохранения ростера отчёт устарел — пересчитываем сами
    this._onRoster = () => this.load()
    window.addEventListener("roster:changed", this._onRoster)
  }

  disconnect() { window.removeEventListener("roster:changed", this._onRoster) }

  esc(s) { const d = document.createElement("div"); d.textContent = s ?? ""; return d.innerHTML }

  // порядок = порядок важности: сначала то, что реально сломает печать
  static LABELS = {
    overflow: ["Не влезло", "bg-[#fdf1f2] text-[#c33245]"],
    empty: ["Пустое значение", "bg-[#fbf7ec] text-[#8a6d20]"],
    shrunk: ["Ужато", "bg-[#eaf5fe] text-[#0f78bb]"],
    ok: ["В порядке", "bg-[#f2f5f8] text-[#6d7e92]"],
  }

  async load() {
    this.buttonTarget.disabled = true
    this.summaryTarget.textContent = "Считаю…"
    const data = await fetch(this.urlValue, { headers: { Accept: "application/json" } })
      .then((r) => (r.ok ? r.json() : null))
      .catch(() => null)
    this.buttonTarget.disabled = false
    if (!data) { this.summaryTarget.textContent = "Не удалось посчитать отчёт"; return }
    this.render(data)
  }

  render({ rows, counts }) {
    const order = Object.keys(this.constructor.LABELS)
    if (!rows.length) {
      this.summaryTarget.textContent = "Персональных надписей в заказе нет"
      this.bodyTarget.innerHTML = ""
      return
    }
    this.summaryTarget.innerHTML = order
      .filter((s) => counts[s] > 0)
      .map((s) => {
        const [label, cls] = this.constructor.LABELS[s]
        return `<span class="inline-flex h-[22px] items-center rounded-full px-[9px] text-xs font-bold ${cls}">${label}: ${counts[s]}</span>`
      }).join(" ")

    // строки, требующие внимания, — наверх; «в порядке» показываем последними
    const sorted = [...rows].sort((a, b) => order.indexOf(a.status) - order.indexOf(b.status))
    this.bodyTarget.innerHTML = sorted.map((r) => this.row(r)).join("")
  }

  row(r) {
    const [label, cls] = this.constructor.LABELS[r.status] || ["—", ""]
    const scale = r.status === "shrunk" || r.status === "overflow" ? `${Math.round(r.scale * 100)} %` : "—"
    const width = r.width_mm == null ? "—" : `${r.width_mm} / ${r.max_width_mm || "∞"} мм`
    return `
      <tr class="border-b border-[#f2f5f8]">
        <td class="px-[14px] py-[9px]">
          <a href="/designs/${r.design_id}/edit?recipient=${r.recipient_id}"
             class="font-semibold text-[#0f78bb] hover:underline">${this.esc(r.recipient_label)}</a>
          <span class="ml-1 text-[#8592a3]">${this.esc(r.size)}</span>
        </td>
        <td class="px-[14px] py-[9px] text-[#1b1f2a]">${this.esc(r.text) || "<span class='text-[#c33245]'>пусто</span>"}</td>
        <td class="px-[14px] py-[9px] text-[#6d7e92]">${width}</td>
        <td class="px-[14px] py-[9px] text-[#6d7e92]">${scale}</td>
        <td class="px-[14px] py-[9px]">
          <span class="inline-flex h-[22px] items-center rounded-full px-[9px] text-xs font-bold ${cls}">${label}</span>
        </td>
      </tr>`
  }
}
